import { render, staticRenderFns } from "./EditStoreOwner.vue?vue&type=template&id=77e83196&"
import script from "./EditStoreOwner.vue?vue&type=script&lang=ts&"
export * from "./EditStoreOwner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports